<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex md4 xs12 pt-2>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.codebooks')}}</b></span><br><br>
				<v-btn color="grey lighten-1" @click="codebookHeating">
					{{ $t('buttons.codebooksHeating') }}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md4 xs12 pt-2>
				<v-btn color="grey lighten-1" @click="additionalInfo">
					{{ $t('buttons.additionalInfo') }}
				</v-btn>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>

export default {
	name: "codebooks",
	components: {},
	data: function () {
		return {

		}
	},
	methods: {
		codebookHeating(){
			this.$router.push('/codebooks/heating');
		},
		additionalInfo(){
			this.$router.push('/codebooks/additional-info');
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.codebooks'), href: '/#/codebooks', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
